import { j as d } from "../../jsx-runtime-Wav_3Wde.js";
import { createContext as u, useContext as i } from "react";
import { C as e } from "../../brands-CoixlYYY.js";
const s = /* @__PURE__ */ u({
  currentBrand: e,
  defaultBrand: e
}), x = ({ brandProviderStrategy: r, brandAllowList: n, defaultBrand: t, ...o }) => ({ children: a }) => {
  const c = {
    currentBrand: r(o),
    defaultBrand: t,
    brandAllowList: n
  };
  return /* @__PURE__ */ d.jsx(s.Provider, {
    value: c,
    children: a
  });
}, p = (r) => {
  const { currentBrand: n, defaultBrand: t, brandAllowList: o = [] } = i(s);
  return (r && Array.isArray(r) ? r : o).includes(n) ? n : t;
};
export {
  s as BrandContext,
  x as brandProviderFactory,
  p as useBrand
};
